import { newsApi } from './api';
import {
    ADD_JOB_ENDPOINT,
    GET_JOB_ENDPOINT,
    GET_JOB_STAS_ENDPOINT,
    JOB_EDIT_ENDPOINT,
    REMOVE_JOB_ENDPOINT
} from "./apiConstant";

export const JobService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getDoc: build.query({
            query: ({ id, pagination }) => ({
                url: `documents/get/${id ? id : 0}${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        addDoc: build.mutation({
            query: (form) => ({
                url: `documents/store`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editDoc: build.mutation({
            query: ({ id, newForm }) => ({
                url: `documents/update/${id}`,
                method: 'POST',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        removeDoc: build.mutation({
            query: (id) => ({
                url: `documents/remove/${id}`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetDocQuery,
    useAddDocMutation,
    useEditDocMutation,
    useRemoveDocMutation
} = JobService